import { axiosInstance } from "../../../Services";

export const GetInventoryData = async ({ limit, page, filters = {} }) => {
  try {
    const params = { limit, page };
    
    // Add filter parameters if they exist
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params[key] = filters[key];
      }
    });

    const res = await axiosInstance.get(`/rsform/inventories`, {
      params,
    });
    return res;
  } catch (error) {
    throw error;
  }
};